import {IntermediatePart} from "../../intermediatePart";
import Appliance from "../../parts/appliance";
import getHoodConditions from "./getHoodConditions";

export default class TopHandle extends IntermediatePart {

  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'top_handle';
    this.partName = 'Top Handle';
    this.canBeDisabled = true;
    this.layerPriority = 2;
    this.translateId = "visualizer.kitchen.cabinet.top_handle";
    this.hasAdditionalParts = true;
  }

  load(dbFeature) {
    const partNumber = (dbFeature.metaData["Part"] && dbFeature.metaData["Part"][0]) === "1" ? 1 : 2;
    return super.load_(dbFeature, new TopHandle(false, partNumber), true, partNumber === 1 ? 'features' : 'featuresParts');
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    return [...conditions, ...getHoodConditions(this.getParent())]
  }

  getActiveFeatureConditions() {
    return this.getArrayOfConditions().filter(metaObject => {
      return metaObject.propName !== "Hood" && metaObject.propName !== "Width" && metaObject.propName !== "HoodHeight"
    })
  }

  getActiveFeaturePartsAccordingToActiveFeature(fromFeature = this.activeFeature, activeFeatureConditions = []) {
    let activeFeatureParts = [];
    if (fromFeature && fromFeature.partNumber) {
      const name1 = fromFeature.getSplittedFeatureName();
      // console.log("name1", name1);
      let arrayOfConditions = activeFeatureConditions.length
        ? activeFeatureConditions
        : this.getActiveFeatureConditions(fromFeature);

      const cabinetParent = this.getParent();
      const applianceParent = cabinetParent.layout.parts[Appliance.id];

      // part1 - depends on hood - H hood enabled, С - disabled
      // part1 - depends on hood "Width"
      // part2 - depends on Fridge
      activeFeatureParts = this.featuresParts.filter((feature) => {
        if (feature.metaData["Part"] && feature.metaData["Part"].includes("2")) {
          const fridgeIsVisible = applianceParent && applianceParent.fridge && !applianceParent.fridge.disabled
            && applianceParent.fridge.activeFeature;
          const fridgeConditions = applianceParent && applianceParent.fridge
            ? applianceParent.fridge.getFridgeWidthAndHeightConditions()
            : [];
          return name1 === feature.getSplittedFeatureName() && feature.matchesMetaForArrayOfConditions([
            ...arrayOfConditions, {
              propName: "Fridge",
              propValue: fridgeIsVisible ? "F" : "C"
            }, ...fridgeConditions
          ])
        } else if (feature.metaData["Part"] && feature.metaData["Part"].includes("3")) {
          if (!applianceParent || !applianceParent.oven || applianceParent.oven.disabled || !applianceParent.oven.activeFeature) {
            return false
          }
          return name1 === feature.getSplittedFeatureName() && feature.matchesMetaForArrayOfConditions(arrayOfConditions)
        }
        return false
      });

      // console.log("this.featuresParts", this.featuresParts);
      // console.log("activeFeatureParts", activeFeatureParts);
      activeFeatureParts.forEach((activeFeaturePart) => {
        activeFeaturePart.disabled = this.disabled
      });
    }
    return activeFeatureParts
  }
}
